import React from 'react';
import cn from 'classnames';
import { CartType } from '@base/cart/useCart';
import { Checkbox } from 'antd';
import styles from './cartMenu.module.less';
import { GroupHeader } from './GroupHeader';
import { GroupFooter } from './GroupFooter';
import CartItem from './CartItem';
import { getGroupItems, isCheckAll } from 'mod/cart/utils';
import RewardCoinTip from '@base/cart/RewardCoinTip'

type CartGroupsProps = {
    cart: CartType;
};


const CartGroups: React.FC<CartGroupsProps> = (props) => {
    const { cart } = props
    const {
        //list
        groups,
        items,
        checkedIds,
        onChangeIds,
        onGroupCheckAll,
        onChangeItemNum,
        onDeleteItem,
        loadCart,
    } = cart;

    return (
        <div className={styles.groups}>
            {groups.map((group, index) => {
                const groupItems = getGroupItems(group, items);
                const groupCheckedIds = checkedIds[group.groupId] || [];
                return (
                    <div key={group.groupId} className={cn(styles.group, {[styles.first]:index===0})}>
                        <GroupHeader
                            data={group.header}
                            groupCheckAll={isCheckAll(groupItems, groupCheckedIds)}
                            onGroupCheckAll={e => {
                                onGroupCheckAll(group, e.target.checked)
                            }}
                            isBatchList={false}
                        />

                        <RewardCoinTip
                            data={group.rewardCoinTip}
                        />

                        <Checkbox.Group
                            value={groupCheckedIds}
                            onChange={ids => onChangeIds(group.groupId, ids)}
                            className="block"
                        >
                            {groupItems.map((item, index) => !item ? null:(
                                <CartItem
                                    key={item.id}
                                    item={item}
                                    index={index}
                                    onChangeItemNum={onChangeItemNum}
                                    onDeleteItem={onDeleteItem}
                                    isBatchList={false}
                                    loadCart={loadCart}
                                    group={group}
                                />
                            ))}
                        </Checkbox.Group>

                        <GroupFooter
                            data={group.footer}
                            iconSize={20}
                        />
                    </div>
                )
            })}
        </div>
    )
};

export default CartGroups;